import { render, staticRenderFns } from "./HomeWhoWeAre.vue?vue&type=template&id=3fa21058&scoped=true&"
import script from "./HomeWhoWeAre.vue?vue&type=script&lang=js&"
export * from "./HomeWhoWeAre.vue?vue&type=script&lang=js&"
import style0 from "./HomeWhoWeAre.vue?vue&type=style&index=0&id=3fa21058&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa21058",
  null
  
)

export default component.exports